import { render, staticRenderFns } from "./create-customer.vue?vue&type=template&id=05a10314&"
import script from "./create-customer.vue?vue&type=script&lang=js&"
export * from "./create-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports